import { render, staticRenderFns } from "./checkLogistics.vue?vue&type=template&id=2d95ed4a&scoped=true&"
import script from "./checkLogistics.vue?vue&type=script&lang=js&"
export * from "./checkLogistics.vue?vue&type=script&lang=js&"
import style0 from "./checkLogistics.vue?vue&type=style&index=0&id=2d95ed4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d95ed4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d95ed4a')) {
      api.createRecord('2d95ed4a', component.options)
    } else {
      api.reload('2d95ed4a', component.options)
    }
    module.hot.accept("./checkLogistics.vue?vue&type=template&id=2d95ed4a&scoped=true&", function () {
      api.rerender('2d95ed4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/checkLogistics.vue"
export default component.exports